import { render, staticRenderFns } from "./Fourth_mobile.vue?vue&type=template&id=59d37e42&scoped=true&"
import script from "./Fourth_mobile.vue?vue&type=script&lang=js&"
export * from "./Fourth_mobile.vue?vue&type=script&lang=js&"
import style0 from "./Fourth_mobile.vue?vue&type=style&index=0&id=59d37e42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d37e42",
  null
  
)

export default component.exports